<template>
  <div class="empresa-plano-card">
    <div class="card-header">
      <div class="pill">{{ plano.tipo }}</div>
    </div>

    <div class="title">
      {{ plano.descricao || descriptions[plano.tipo] }}
    </div>

    <div class="preco">
      <div class="preco-plano" v-if="plano.preco_plano">
        <div class="simbolo">R$</div>
        <div class="valor">
          {{ precoCliente != null ? precoCliente : preco }}
        </div>
        <div class="price-description">
          {{ priceDescription[plano.tipo] }}
        </div>
      </div>
      <div class="sob-consulta" v-else>Sob consulta</div>
    </div>

    <div class="recursos-list" v-if="recursos.length">
      <div class="recursos-title">O que está incluído</div>
      <div
        v-for="(recurso, index) in recursos"
        :key="index"
        class="d-flex flex-row mb-1 recurso-row"
      >
        <v-icon size="18" class="icon-list" color="primary">mdi-check-circle-outline</v-icon>
        <div class="recurso-item d-flex flex-column" v-if="recurso.faturar">
          <div class="d-flex flex-row">
            <div class="recurso-nome">
              {{ recurso.nome }}
            </div>
            &nbsp;-&nbsp;
            <span class="font-weight-bold">{{ recurso.preco | preco }}</span>
            <span class="font-weight-bold">
              &nbsp;
              ({{ recurso.recorrencia }})
            </span>
          </div>
        </div>
        <div class="recurso-item d-flex" v-else>
          <div class="recurso-nome">(Incluso) {{ recurso.nome }}</div>
        </div>
      </div>
    </div>

    <div class="text-center mt-auto pt-4">
      <v-btn color="primary" depressed @click="$emit('on-select-plan', plano.id)" class="select-plan" rounded>
        <span>Selecionar plano</span>
      </v-btn>
    </div>
  </div>
</template>
<script>
export default {
 props: {
  plano: {
   required: true,
   type: Object,
  },
 },
 data() {
  return {
   descriptions: {
    assinatura:
     'Exames complementares não estão inclusos no plano. Pague esse valor para cada assinatura contratada',
    mrr:
     'Exames complementares não estão inclusos no plano. Pague esse valor para cada funcionário cadastrado',
    avulso: 'Exames clínicos ocupacionais e complementares não estão inclusos no plano. ',
   },
   priceDescription: {
    avulso: '/Exame Ocupacional',
    assinatura: '/Assinatura'
   }
  }
 },
 computed: {
  preco() {
   return this.plano.preco_plano ? this.plano.preco_plano.toFixed(2).replace('.', ',') : ''
  },
  precoCliente() {
   return this.plano.preco_cliente != null ? this.plano.preco_cliente.toFixed(2).replace('.', ',') : null
  },
  recursos() {
   return this.plano.produtos ? this.plano.produtos.concat(this.plano.modulos) : []
  },
 },
}
</script>
<style lang="scss">
.empresa-plano-card {
  background-color: #ffffff;
  border-radius: 18px;
  padding: 20px 22px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.04);
  transition: transform 150ms ease, box-shadow 150ms ease, border-color 150ms ease;
  height: 100%;
  min-height: 360px;

  &:hover {
    outline: 1px solid var(--v-primary-base);
  }

  .card-header {
    display: flex;
    justify-content: flex-start;
    min-height: 28px;
    align-items: center;
  }

  .pill {
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: var(--v-primary-base);
    background-color: rgba(0, 0, 0, 0.02);
  }

  .title {
    font-size: 1rem !important;
    color: #0f172a;
    min-height: 52px;
    line-height: 1.3;
  }

  .preco {
    color: var(--v-primary-base);
    font-weight: 700;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    margin-top: 4px;
    user-select: none;
    min-height: 52px;

    .preco-plano {
      display: flex;
      flex-direction: row;
      align-items: flex-end;
    }

    .simbolo {
      font-size: 0.9rem;
      margin-right: 4px;
      margin-bottom: 6px;
      color: #64748b;
    }

    .valor {
      font-size: 2.1rem;
      line-height: 1;
    }

    .sob-consulta {
      font-size: 1rem;
      color: #0f172a;
    }
  }

  .price-description {
    font-size: 0.8rem;
    margin-left: 8px;
    margin-bottom: 4px;
    color: #64748b;
  }

  .recursos-list {
    display: flex;
    flex-direction: column;
    margin-top: 12px;
    gap: 4px;
    flex-grow: 1;
    height: 180px;
  }

  .recurso-row {
    align-items: flex-start;
  }

  .recurso-nome {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 12vw;
  }

  .recurso-item {
    font-size: 0.8rem;
    color: #475569;
    margin-left: 6px;
  }

  .recursos-title {
    margin-bottom: 6px;
    font-size: 0.78rem;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: #94a3b8;
    font-weight: 600;
  }

  .icon-list {
    color: var(--v-primary-base) !important;
  }

  .select-plan {
    font-size: 0.85rem;
    font-weight: 600;
    text-transform: none;
    min-height: 40px;
  }
}

@media (max-width: 960px) {
  .empresa-plano-card {
    padding: 18px 16px;

    .recurso-nome {
      max-width: 60vw;
    }
  }
}
</style>
